import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Droppable } from 'react-beautiful-dnd'

import { getAvailableEquipmentTypes, getStageElementsByTypes } from '../../../functions'

import ListEquipmentItem from './list-equipment-item'

class ListEquipment extends Component {
  constructor(props) {
    super(props)

    this.state = {}
  }

  render() {
    const { view, columns, itemId, items, stageElements } = this.props

    const availableEquipmentTypes = getAvailableEquipmentTypes(columns, items)

    const options = getStageElementsByTypes(availableEquipmentTypes.ids, stageElements)
    const categories = availableEquipmentTypes.objects

    return (
      <div className="list-equipment">
        <Droppable droppableId={itemId} type={`equipment-${itemId}`}>
          {(provided, snapshot) => (
            <div className="list-equipment--droppable"
              ref={provided.innerRef} >
              {
                items.map((item, index) => {
                  return item.class === 'equipment'
                  ? <ListEquipmentItem key={item.id || index}
                      view={view}
                      group={this.props.group}
                      item={item}
                      parentId={itemId}
                      required={item.required}
                      createRiderColumn={this.props.createRiderColumn}
                      removeRiderItem={this.props.removeRiderItem}
                      createRiderItem={this.props.createRiderItem}
                      editRiderItem={this.props.editRiderItem}
                      deleteRiderItem={this.props.deleteRiderItem}
                      stageElements={this.props.stageElements}
                      options={options}
                      categories={categories}
                      getSearchResults={this.props.getSearchResults} />
                  : null
                })
              }

              {provided.placeholder}
            </div>
          )}
        </Droppable>

        {
          view.editable
          ? categories.length > 0
            ? <button className="list--add-button button--inline" onClick={() => {
                this.props.addRiderItem({
                  class: "equipment",
                  position: items.length+1,
                  parent: itemId,
                  indexes:
                    this.props.parentItemIndex !== undefined
                    ? [
                        this.props.parentItemIndex,
                        this.props.itemIndex,
                        items.length
                      ]
                    : [
                        this.props.itemIndex,
                        items.length
                      ]
                })
              }}>
                + Add equipment to this instrument
              </button>
            : <p>For adding new equipment, please create additional column in Compact view.</p>
          : null
        }
      </div>
    )
  }
}

ListEquipment.propTypes = {
  view: PropTypes.object,
  group: PropTypes.string,
  columns: PropTypes.array,
  itemId: PropTypes.string,
  itemIndex: PropTypes.number,
  parentItemIndex: PropTypes.number,
  items: PropTypes.array,
  createRiderColumn: PropTypes.func,
  addRiderItem: PropTypes.func,
  removeRiderItem: PropTypes.func,
  createRiderItem: PropTypes.func,
  editRiderItem: PropTypes.func,
  deleteRiderItem: PropTypes.func,
  stageElements: PropTypes.object,
  getSearchResults: PropTypes.func
}

ListEquipment.defaultProps = {
  view: {},
  group: '',
  columns: [],
  itemId: '',
  itemIndex: undefined,
  parentItemIndex: undefined,
  items: [],
  createRiderColumn: function() {},
  addRiderItem: function() {},
  removeRiderItem: function() {},
  createRiderItem: function() {},
  editRiderItem: function() {},
  deleteRiderItem: function() {},
  stageElements: {},
  getSearchResults: function() {}
}

export default ListEquipment



// WEBPACK FOOTER //
// ./src/components/rider/rider-input/input-list/list-equipment.js